export enum IconScale {
  XXS = 10,
  XS = 12,
  S = 16,
  M = 24,
  L = 32,
  XL = 40,
}

export interface IIconsProps {
  color?: string;
  fillcolor?: string;
  size?: IconScale;
  height?: number;
  width?: number;
}
